import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ContactUs from "./routes/pages/contactUs";
import HomeCharing from "./routes/pages/home-charging";
import LandingPage from "./routes/pages/landing";
import NotFoundPage from "./routes/pages/notFound";
import Privacy from "./routes/pages/privacy";
import Report from "./routes/pages/report";
import TERMS from "./routes/pages/terms";
import { ROUTE_PATHS } from "./routes/paths/route-paths";

function App() {
  const router = createBrowserRouter([
    {
      path: ROUTE_PATHS.LANDING_PAGE,
      element: <LandingPage />,
    },
    {
      path: ROUTE_PATHS.CONTACT_US_PAGE,
      element: <ContactUs />,
    },
    {
      path: ROUTE_PATHS.PRIVACY_PAGE,
      element: <Privacy />,
    },
    {
      path: ROUTE_PATHS.TERMS_PAGE,
      element: <TERMS />,
    },
    {
      path: ROUTE_PATHS.HOME_CHARGIN_PAGE,
      element: <HomeCharing />,
    },
    {
      path: ROUTE_PATHS.REPORT_PAGE,
      element: <Report />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
      <ToastContainer />
    </>
  );
}

export default App;
